/*global define, console, window, HTMLImageElement, Promise*/
(window.MyModule = function ($, Behaviors) {
    "use strict";
    var module = {};
    function MilesCounter(elem) {
        Behaviors.init(MilesCounter, this, arguments);
        var $thisElem = this.$elem;
        
        // const Odometer = require('odometer.js');
        function initOdometer(el) {
            const $odometer = $(el).find('.mileage__counter');

            if ($odometer.length) {
                
                const hour = new Date().getHours();
                const isNight = hour < 8 || hour >= 20;
                const mileage = $odometer.data('mileage');
                const dayRate = 6 / parseFloat($odometer.data('rate_day'));
                const nightRate = 6 / parseFloat($odometer.data('rate_night'));
                const rate = isNight ? nightRate * 1000 : dayRate * 1000;
                $odometer.toggleClass('mileage__counter--night', isNight);
                let odometerValue = mileage + (isNight ? nightRate : dayRate);
                const odometer = new Odometer({
                el: $odometer.get(0),
                value: odometerValue,
                format: '(,d,ddd,dddd)',
                theme: 'minimal',
                duration: rate,
                });

                setInterval(function() {
                    odometerValue += 1;
                    odometer.update(odometerValue);
                }, rate);

                $odometer.get(0).style.setProperty('--day-rate', `${dayRate}s`);
                $odometer.get(0).style.setProperty('--night-rate', `${nightRate}s`);
            }
        }

        if (typeof window.acf !== 'undefined') {
            window.acf.addAction('render_block_preview/type=odometer', initOdometer);
        } else {
            $('.MilesCounter-content').each((index, el) => initOdometer(el));
        }
        
    }
    Behaviors.inherit(MilesCounter, Behaviors.Behavior);
    MilesCounter.QUERY = "[data-MilesCounter]";
    MilesCounter.ELEMENTS = {
        loadMoreButton: ".AwardTabs-content_tabs_items_item_loadMore__button",
    };
    Behaviors.register_behavior(MilesCounter);
    module.MilesCounter = MilesCounter;
    return module;
}(window.jQuery, window.Behaviors));
